import type { PropertyValidationResult } from '../../../types/properties';

export default function validator(properties: Record<string, any>): PropertyValidationResult {
  const errors: Array<{ key: string; message: string }> = [];

  // Validate inputArray
  if (!properties.inputArray || properties.inputArray.trim() === '') {
    errors.push({
      key: 'inputArray',
      message: 'Input Array is required',
    });
  }

  // Validate conditions
  const conditions = properties.conditions?.values || [];
  if (conditions.length === 0) {
    errors.push({
      key: 'conditions',
      message: 'At least one condition is required',
    });
  } else {
    conditions.forEach((condition: any, index: number) => {
      if (!condition.field || condition.field.trim() === '') {
        errors.push({
          key: `conditions.values[${index}].field`,
          message: 'Field is required',
        });
      }
      if (!condition.operator) {
        errors.push({
          key: `conditions.values[${index}].operator`,
          message: 'Operator is required',
        });
      }
      // Value is only required for operators that need it
      const operatorsWithoutValue = ['isEmpty', 'isNotEmpty'];
      if (!operatorsWithoutValue.includes(condition.operator)) {
        if (condition.value === undefined || condition.value === null || condition.value === '') {
          errors.push({
            key: `conditions.values[${index}].value`,
            message: 'Value is required for this operator',
          });
        }
      }
    });
  }

  return {
    valid: errors.length === 0,
    errors,
  };
}
